import _useMediaQuery from "@material-ui/core/esm/useMediaQuery";
import React, { useState, useLayoutEffect, useRef } from 'react';
import { RouteTabs } from 'swag-client-common/components/partials-custom-store/route-tabs';
import { getTabStyles } from './goodie-giveaway-tabs-styles';
import responsiveClasses from './goodie-giveaway-tabs.scss';
import fixedClasses from './goodie-giveaway-tabs-fixed.scss';
export const GoodieGiveawayTabs = ({
  currentTab,
  tabs,
  isFixed = false,
  giveawayColor
}) => {
  const classes = isFixed ? fixedClasses : responsiveClasses;
  const tabsRef = useRef(null);
  const tabsWrapperRef = useRef(null);
  const isMobileScreen = _useMediaQuery('(max-width:1151px)');
  const isLargeScreen = _useMediaQuery('(min-width:2560px)');
  const linkStyle = getTabStyles({
    isMobileScreen,
    isLargeScreen,
    isFixed
  });
  const [areTabsCentered, setAreTabsCentered] = useState(true);
  useLayoutEffect(() => {
    var _tabsRef$current, _tabsWrapperRef$curre;
    const tabsWidth = tabsRef === null || tabsRef === void 0 ? void 0 : (_tabsRef$current = tabsRef.current) === null || _tabsRef$current === void 0 ? void 0 : _tabsRef$current.clientWidth;
    const tabsWrapperWidth = tabsWrapperRef === null || tabsWrapperRef === void 0 ? void 0 : (_tabsWrapperRef$curre = tabsWrapperRef.current) === null || _tabsWrapperRef$curre === void 0 ? void 0 : _tabsWrapperRef$curre.clientWidth;
    if (!tabsWidth || !tabsWrapperWidth) {
      return;
    }
    const areTabsCentered = tabsWrapperWidth >= tabsWidth;
    setAreTabsCentered(areTabsCentered);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    ref: tabsWrapperRef,
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement(RouteTabs, {
    ref: tabsRef,
    tabs: tabs,
    currentTab: currentTab,
    linkStyles: linkStyle,
    areTabsCentered: areTabsCentered,
    color: giveawayColor,
    tabIndicatorProps: {
      className: classes.indicator
    },
    classes: {
      root: classes.tabsRoot,
      flexContainer: classes.tabsFlexContainer
    }
  }));
};